import { jsxs as l, Fragment as t, jsx as m } from "react/jsx-runtime";
import n from "classnames";
import s from "./index.es5602.js";
const p = ({
  ColorIndicator: r,
  size: a = "small",
  LeftIcon: e
}) => /* @__PURE__ */ l(t, { children: [
  r && /* @__PURE__ */ m("span", { className: n(s.entityColor, s[a]), children: r }),
  e && /* @__PURE__ */ m("span", { className: s.leftIcon, children: e })
] });
export {
  p as ChipDecoration
};
//# sourceMappingURL=index.es5601.js.map
